<template>
  <div class="box">
    <div class="main">
      <div class="statistics">
        <div class="title">2019年第一季度涉旅经营户品质指数评价法说服或分三节课哈师傅</div>
        <div class="completionDate">目标完成日期：2019-11-22</div>
        <div class="approvalStatus">
          <div class="mode2" v-show="isOver && throughExamine">审核通过</div>
          <div class="seeTheExamineText" @click="handleSeeExamineText" v-show="isOver">
            <span v-if="theExamineText !== ''">查看审核意见</span>
            <span v-if="theExamineText ===''">⽆审核意⻅</span>
            <div class="theExamineTextIcom">
              <img
                src="../../../../assets/image/ic_xl.png"
                v-show="isShowTheExamineText && theExamineText !== ''"
              />
              <img
                src="../../../../assets/image/ic_xl_down.png"
                v-show="!isShowTheExamineText && theExamineText !== ''"
              />
            </div>
          </div>
        </div>
        <div class="theExamineTextBox" v-show="isShowTheExamineText">
          <p class="theExamineText" :class="{'showSome': isShowAllExamineText}">
            这里是一段审核意见，业务上不限制字数。这里是一段这里是一段审核意见，业务上不限制字数。这里是一段
            这里是一段审核意见，业务上不限制字数。这里是一段这里是一段审核意见，业务上不限制字数。这里是一段段
          </p>
          <div class="showAllExamineTextBtn" @click="handleClickAllExamineTex">
            <span v-show="isShowAllExamineText">展开</span>
            <span v-show="!isShowAllExamineText">收起</span>
            <div class="showAllExamineTextIcon">
              <img
                v-show="isShowAllExamineText"
                src="../../../../assets/image/ic_jiantou_down.png"
                alt
              />
              <img
                v-show="!isShowAllExamineText"
                src="../../../../assets/image/ic_jiantou_up.png"
                alt
              />
            </div>
          </div>
        </div>
      </div>
      <div class="dataListBox">
        <div class="dataListNav">
          <div
            class="dataListNavItem"
            v-for="(item, index) in dataListNavList"
            :key="index"
            v-show="item.isShow"
            :class="{'active':isDlNavItem === index}"
            @click="handleDlNavItemActive(index)"
          >{{item.name}}</div>
        </div>
        <div class="choiceIndustryBox" v-if="isDlNavItem === 0">
          <div class="choiceIndustryBtn" @click="handleChoiceIndustryPop">
            <span class="choiceIndustryBtnText">{{industryText.text}}</span>
            <div class="choiceIndustryBtnIcon">
              <img src="../../../../assets/image/xiala.png" />
            </div>
          </div>
          <div class="allListCounts">共3个工单</div>
        </div>
        <!-- 评分对象列表 -->
        <div class="scoreObjectList" v-if="isDlNavItem === 0">
          <div class="scoreObjectListItem" v-for="(item,index) in workOrderPageList" :key='index'>
            <p class="scoreObjectId">工单ID:{{item.workOrderId}}</p>
            <div class="scoreObjectNameBox">
              <div class="scoreObjectName">{{item.enterpriseName}}</div>
              <div class="scoreObjectTo">
                <span>{{item.result}}</span>
                <div>
                  <img src="../../../../assets/image/t-right.png" />
                </div>
              </div>
            </div>
            <div class="scoreObjectBages">
              <div class="locationBage">{{item.regionName}}</div>
              <div class="industryBage">{{item.industryCategoryName}}</div>
            </div>
          </div>
          <div class="scoreObjectListItem" @click="toPageDetailOrders">
            <p class="scoreObjectId">{{'工单ID：234332432345676543'}}</p>
            <div class="scoreObjectNameBox">
              <div class="scoreObjectName">昆明五华区新丽来饭店</div>
              <div class="scoreObjectTo">
                <span>未开始</span>
                <div>
                  <img src="../../../../assets/image/t-right.png" />
                </div>
              </div>
            </div>
            <div class="scoreObjectBages">
              <div class="locationBage">昆明市-五华区</div>
              <div class="industryBage">餐饮</div>
            </div>
          </div>
          <div class="scoreObjectListItem">
            <p class="scoreObjectId">{{'工单ID：234332432345676543'}}</p>
            <div class="scoreObjectNameBox">
              <div class="scoreObjectName">昆明五华区新丽来饭店</div>
              <div class="scoreObjectTo">
                <span>未开始</span>
                <div>
                  <img src="../../../../assets/image/t-right.png" />
                </div>
              </div>
            </div>
            <div class="scoreObjectBages">
              <div class="locationBage">昆明市-五华区</div>
              <div class="industryBage">餐饮</div>
            </div>
          </div>
        </div>
        <!-- 任务信息列表 -->
        <div class="taskDetailList" v-if="isDlNavItem === 1">
          <div class="taskDetailListItem">
            <div class="taskDetailTitle">创建时间:</div>
            <p>2019-11-15 10:30</p>
          </div>
          <div class="taskDetailListItem">
            <div class="taskDetailTitle">受委托方:</div>
            <p>{{ratingTaskInfoData.unitName}}</p>
          </div>
          <div class="taskDetailListItem">
            <div class="taskDetailTitle">涉及行业类别:</div>
            <p>{{ratingTaskInfoData.industryCategory}}</p>
          </div>
          <div class="taskDetailListItem">
            <div class="taskDetailTitle">任务描述:</div>
            <p>{{ratingTaskInfoData.memo}}</p>
          </div>
        </div>
        <!-- 操作记录列表 -->
        <div class="operationRecordList" v-if="isDlNavItem === 2">
          <div class="operationListItem" v-for="(item, index) in operationRecordList" :key="index">
            <h5 class="operationTitle">{{item.operationTitle}}</h5>
            <div class="operationTime">{{item.operationTime}}</div>
            <div class="operaterBox">{{'操作人：' + item.operater}}</div>
            <p class="operationDetail">{{item.operationDetail}}</p>
            <span class="timePoint"></span>
          </div>
        </div>
      </div>
      <!--
            <div class="content">
                <van-tabs v-model="active">
                    <van-tab title="评分对象">
                        <div class="industryChoice">
                            <div class="choice">全部行业</div>
                            <div class="workOderNum">共3个工单</div>
                        </div>
                        <div class="list">
                            <ul>
                                <li>
                                    <div class="left">
                                        <div class="workOrderID">工单ID：234332432345676543</div>
                                        <div class="associationName">昆明五华区新丽来饭店</div>
                                        <div class="sign">
                                            <div class="adress">昆明市-五华区</div>
                                            <div class="classification">餐饮</div>
                                        </div>
                                    </div>
                                    <div class="right">未开始></div>
                                </li>
                                <li>
                                    <div class="left">
                                        <div class="workOrderID">工单ID：234332432345676543</div>
                                        <div class="associationName">昆明五华区新丽来饭店</div>
                                        <div class="sign">
                                            <div class="adress">昆明市-五华区</div>
                                            <div class="classification">餐饮</div>
                                        </div>
                                    </div>
                                    <div class="right">未开始></div>
                                </li>
                                <li>
                                    <div class="left">
                                        <div class="workOrderID">工单ID：234332432345676543</div>
                                        <div class="associationName">昆明五华区新丽来饭店</div>
                                        <div class="sign">
                                            <div class="adress">昆明市-五华区</div>
                                            <div class="classification">餐饮</div>
                                        </div>
                                    </div>
                                    <div class="right">未开始></div>
                                </li>
                                <li>
                                    <div class="left">
                                        <div class="workOrderID">工单ID：234332432345676543</div>
                                        <div class="associationName">昆明五华区新丽来饭店</div>
                                        <div class="sign">
                                            <div class="adress">昆明市-五华区</div>
                                            <div class="classification">餐饮</div>
                                        </div>
                                    </div>
                                    <div class="right">未开始></div>
                                </li>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="任务信息">
                        <div class="missionInformation">
                            <div class="createMessage">
                                <div class="left">创建时间</div>
                                <div class="right">2019-11-15  10:30</div>
                            </div>
                            <div class="commissionedParty">
                                <div class="left">受委托方</div>
                                <div class="right">XX评分单位</div>
                            </div>
                            <div class="involvedIndustries">
                                <div class="left">涉及行业类别</div>
                                <div class="right">旅游住宿、餐饮企业</div>
                            </div>
                            <div class="missionDetails">
                                <div class="left">任务描述</div>
                                <div class="right">任务详情描述，任务详情描述，任务详情描述</div>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
      -->
      <common-picker
        ref="isShowIndustryPop"
        :typeList="industryList"
        :cols="cols1"
        @getTypeValue="getTypeValue"
      ></common-picker>
      <van-popup
        class="examinePicker"
        v-model="isShowExaminePicker"
        position="bottom"
        @close="retunThroughExamineActive"
        :style="{ minHeight: '232px'}"
      >
        <h5 class="examinePickerTitle">审核结果</h5>
        <div class="examineBtns">
          <div
            class="throughExamine"
            :class="{'active': isThroughExamine}"
            @click="changeThroughExamine"
          >通过</div>
          <div
            class="notThroughExamine"
            :class="{'active': isNotThroughExamine}"
            @click="changeNotThroughExamine"
          >不通过</div>
        </div>
        <div class="examineMiddleBox">
          <div class="examineOpinionBox" v-show="isThroughExamine">
            <van-checkbox v-model="checked" checked-color="#07c160">填写审核意见</van-checkbox>
          </div>
          <div class="notThroughExamineTitile" v-show="isNotThroughExamine">
            审核意见
            <span>必填</span>
          </div>
          <div
            v-show="(checked && isThroughExamine) || isNotThroughExamine"
            class="throughExamineTextBox"
          >
            <van-field
              class="throughExamineText"
              v-model="throughExamineText"
              autosize
              type="textarea"
              placeholder="请在这里输入您的审核意⻅"
            />
          </div>
        </div>
        <div
          class="submitBtn"
          :class="{'active': isThroughExamine || isNotThroughExamine}"
          @click="handleSubmitExamine"
        >提交</div>
      </van-popup>
      <transition name="fade">
        <div
          class="examineDetailTipsBox"
          transition="fade"
          v-show="examineDetailTips"
          @click="handleTest"
        >
          <img src="../../../../assets/image/icon_ts_tg.png" v-if="tipsIcon" />
          <img src="../../../../assets/image/icon_ts_gx.png" v-if="!tipsIcon" />
          <p>{{tipsIcon?'审核通过':'失败示例'}}</p>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
    import commonPicker from '../../../../components/base/commonPicker';
    import api from '../../../../service/modules/integrity'
    export default {
        components: {
            commonPicker
        },
        data () {
            return {
                active: '',
                isOver: true, // 是否完成
                // 审核意见文本
                theExamineText: '1',
                // 是否查看审核意见文本
                isShowTheExamineText: false,
                // 展示全部审查文本
                isShowAllExamineText: false,
                // 是否通过审核
                throughExamine: true,
                isDlNavItem: 0,
                dataListNavList: [
                    { name: '评分对象', isShow: true },
                    { name: '任务信息', isShow: true },
                    { name: '操作记录', isShow: false }
                ],
                // 行业标签
                industryText: { text: '全部行业', type: '' },
                // 选择行业弹窗List
                industryList: [
                    [
                        { text: '全部行业', type: '' },
                        { text: '旅行社', type: '' },
                        { text: '酒店', type: '' },
                        { text: '租赁⻋', type: '' }
                    ]
                ],
                cols1: 1,
                // 审核Picker弹出层
                isShowExaminePicker: false,
                isThroughExamine: false,
                isNotThroughExamine: false,
                checked: false,
                throughExamineText: '',
                // 操作记录按钮测试列表
                operationRecordList: [
                    {
                        operationTitle: '完成评分任务',
                        operationTime: '2019-09-03   01:51',
                        operater: '韩梅梅',
                        operationDetail: ''
                    },
                    {
                        operationTitle: '开始评分',
                        operationTime: '2019-09-02   01:51',
                        operater: '张翠花',
                        operationDetail: ''
                    },
                    {
                        operationTitle: '开始评分任务委托评分单位',
                        operationTime: '2019-09-02   01:51',
                        operater: '系统',
                        operationDetail: ''
                    },
                    {
                        operationTitle: '评分任务审核通过',
                        operationTime: '2019-09-02   01:51',
                        operater: '王小明-昆明市旅发委',
                        operationDetail: ''
                    },
                    {
                        operationTitle: '修改评分任务',
                        operationTime: '2019-09-02   01:51',
                        operater: '王小明-昆明市旅发委',
                        operationDetail: ''
                    },
                    {
                        operationTitle: '评分任务审核不通过',
                        operationTime: '2019-09-02   01:51',
                        operater: '王小明-昆明市旅发委',
                        operationDetail: '核对人员名单233家酒店，文件名单221，漏掉了2家请核实'
                    },
                    {
                        operationTitle: '创建评分任务',
                        operationTime: '2019-09-02   01:51',
                        operater: '操作人：王小明-昆明市旅发委',
                        operationDetail: ''
                    }
                ],
                // 提交按钮提交完的tip状态
                examineDetailTips: false,
                tipsIcon: true,
                queryId: '',
                workOrderPageList: [], // 评分对象列表
                workOrderPageTotal: '', // 评分列表数量
                ratingTaskInfoData: {} // 任务信息
            };
        },
        created () {
            this.queryId = this.$route.query.queryId;
            this.handleList()
            this.getratingTaskInfo()
        },
        mounted () {
            this.isShowOperationBtn();
            // let obj ={};
            // let arr=[];
            // let arr2=[{text: '--', value: '--'}]
            // obj.children=[]

            // console.log(obj.children.concat(arr).concat(arr2))
        },
        methods: {
            // 任务信息
            handleList () {
                let parm = {
                    id: this.queryId
                }
                api.taskDetails(parm).then(res => {
                    console.log(1111111, res)
                })
            },
            // 评分任务详情
            getratingTaskInfo () {
                let parm = {
                    taskId: this.queryId,
                    pageIndex: 1,
                    pageSize: 100
                }
                api.ratingTaskInfo(parm).then(res => {
                    if (res.ret === 0) {
                        this.workOrderPageList = res.data.list
                        this.workOrderPageTotal = res.data.pageination.total
                    }
                })
            },
            toPageDetailOrders (item) {
                this.$router.push({
                    path: 'workOrder', query: { id: item.id }
                })
            },
            handleTest () {
                this.examineDetailTips = false;
            },
            showContent () {
                this.isShowOperationBtn();
            },
            // 点击展开审查文本第一层
            handleSeeExamineText () {
                if (this.theExamineText === '') {
                } else {
                    this.isShowTheExamineText = !this.isShowTheExamineText;
                }
            },
            // 点击展开审查文本第二层
            handleClickAllExamineTex () {
                this.isShowAllExamineText = !this.isShowAllExamineText;
            },
            // 判断是否显示操作记录按钮
            isShowOperationBtn () {
                // this.isOver = !this.isOver;
                // if(this.isOver)
                this.dataListNavList[2].isShow = this.isOver;
            },
            // 数据列表导航状态切换
            handleDlNavItemActive (index) {
                this.isDlNavItem = index;
            },
            // 选择行业弹窗事件
            handleChoiceIndustryPop () {
                // this.isShowIndustryPop = true
                this.$refs.isShowIndustryPop.showPicker();
            },
            // 取消行业弹窗事件
            // handleCancelIndustryPop () {
            // //    this.$refs.isShowIndustryPop.showPicker();
            // },
            getTypeValue (data) {
                this.industryText.text = data[0].text;
                this.industryText.type = data[0].type;
            },
            // 审核弹窗事件
            handleShowExaminePop () {
                this.isShowExaminePicker = true;
            },
            // 通过按钮事件
            changeThroughExamine () {
                this.isThroughExamine = !this.isThroughExamine;
                if (this.isNotThroughExamine) {
                    this.isNotThroughExamine = !this.isNotThroughExamine;
                }
            },
            // 不通过按钮事件
            changeNotThroughExamine () {
                this.isNotThroughExamine = !this.isNotThroughExamine;
                if (this.isThroughExamine) {
                    this.isThroughExamine = !this.isThroughExamine;
                }
            },
            // 弹窗消失按钮状态取消
            retunThroughExamineActive () {
                this.isThroughExamine = false;
                this.isNotThroughExamine = false;
            },
            // 审核提交按钮事件
            handleSubmitExamine () {
                // 发起请求
                // 接收到响应展示对应tips
                if (this.isThroughExamine) {
                    this.tipsIcon = true;
                } else {
                    this.tipsIcon = false;
                }
                this.isShowExaminePicker = false;
                this.examineDetailTips = true;
                let t = setTimeout(() => {
                    this.examineDetailTips = false;
                    clearInterval(t);
                }, 1000);
            }
        }
    };
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  height: 100%;
  padding: 20px 12px;
  box-sizing: border-box;
  background-color: #fbfbfb;

  .main {
    width: 100%;
    background-color: #fff;

    .statistics {
      width: 100%;
      // height: 137px;
      padding: 12px 16px;
      box-sizing: border-box;
      border-bottom: 1px solid #eeeeee;

      .title {
        color: #333;
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
      }

      .completionDate {
        color: #999;
        font-size: 14px;
        margin-top: 8px;
      }

      .approvalStatus {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 12px;

        .mode {
          font-size: 14px;
          color: #ff8c19;
          line-height: 28px;
        }

        .mode2 {
          font-size: 14px;
          color: #36b374;
          line-height: 28px;
        }

        .mode3 {
          font-size: 14px;
          color: #ff4d4d;
          line-height: 28px;
        }

        .review {
          width: 64px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          font-size: 12px;
          background-color: #36b374;
          color: #fff;
          border-radius: 2px;
        }

        .seeTheExamineText::after {
          content: "";
          display: block;
          clear: both;
        }

        .seeTheExamineText {
          > span {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333;
            line-height: 28px;
            float: left;
          }

          .theExamineTextIcom {
            width: 12px;
            height: 12px;
            margin-left: 4px;
            float: left;

            > img {
              width: 100%;
              height: 100%;
              position: relative;
              top: 8px;
            }
          }
        }
      }

      .theExamineTextBox {
        padding: 8px 12px 4px;
        background-color: #f8f8f8;
        border-radius: 3px;

        > p {
          min-height: 76px;
          font-size: 12px;
          line-height: 20px;
        }

        > p.showSome {
          height: 76px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
        }

        .showAllExamineTextBtn::after {
          content: "";
          display: block;
          clear: both;
        }

        .showAllExamineTextBtn {
          height: 20px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: bold;
          text-align: center;
          line-height: 20px;
          color: #333;

          .showAllExamineTextIcon {
            width: 6px;
            height: 4px;
            margin-left: 4px;
            display: inline-block;
            position: relative;
            top: -2px;

            > img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    .dataListBox {
      padding: 3px 16px;
      background-color: #fff;

      .dataListNav::after {
        content: "";
        display: block;
        clear: both;
      }

      .dataListNav {
        margin-bottom: 16px;

        .dataListNavItem {
          margin-right: 24px;
          font-size: 14px;
          font-weight: 400;
          text-align: center;
          line-height: 30px;
          color: #333;
          border-top: 2px solid transparent;
          border-bottom: 2px solid transparent;
          float: left;
        }

        .dataListNavItem.active {
          color: #36b374;
          border-bottom-color: #36b374;
        }
      }

      .choiceIndustryBox::after {
        content: "";
        display: block;
        clear: both;
      }

      .choiceIndustryBox {
        margin-bottom: 20px;
        padding: 8px 0 0;

        .choiceIndustryBtn::after {
          content: "";
          display: block;
          clear: both;
        }

        .choiceIndustryBtn {
          font-size: 14px;
          font-weight: bold;
          line-height: 14px;
          text-align: center;
          color: #333;
          float: left;

          .choiceIndustryBtnText {
            margin-right: 5px;
            float: left;
          }

          .choiceIndustryBtnIcon {
            width: 6px;
            height: 4px;
            float: left;
            position: relative;
            top: 5px;

            > img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .allListCounts {
          font-size: 12px;
          line-height: 14px;
          color: #999;
          float: right;
        }
      }

      .scoreObjectList {
        .scoreObjectListItem {
          margin-bottom: 16px;

          .scoreObjectId {
            font-size: 12px;
            line-height: 20px;
            color: #999999;
          }

          .scoreObjectNameBox::after {
            content: "";
            display: block;
            clear: both;
          }

          .scoreObjectNameBox {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;

            .scoreObjectName {
              width: 210px;
              overflow: hidden;
              text-overflow: ellipsis;
              color: #333;
              white-space: nowrap;
              float: left;
            }

            .scoreObjectTo::after {
              content: "";
              display: block;
              clear: both;
            }

            .scoreObjectTo {
              float: right;

              > span {
                margin-right: 4px;
                line-height: 22px;
                color: #999;
                float: left;
              }

              > div {
                width: 12px;
                height: 12px;
                float: left;
                position: relative;
                top: 5px;

                > img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }

          .scoreObjectBages::after {
            content: "";
            display: block;
            clear: both;
          }

          .scoreObjectBages {
            padding: 4px 0;

            .locationBage {
              padding: 0 4px;
              margin-right: 4px;
              font-size: 10px;
              line-height: 16px;
              color: #fff;
              background-color: #36b374;
              border: 1px solid #36b374;
              float: left;
            }

            .industryBage {
              padding: 0 4px;
              font-size: 10px;
              line-height: 16px;
              color: #36b374;
              border: 1px solid #36b374;
              float: left;
            }
          }
        }
      }

      .taskDetailList {
        .taskDetailListItem::after {
          content: "";
          display: block;

          clear: both;
        }

        .taskDetailListItem {
          height: 30px;
          padding: 4px 0;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          // overflow: hidden;
          .taskDetailTitle {
            width: 96px;
            color: #999;
            float: left;
          }

          > p {
            margin-left: 96px;
          }
        }
      }

      .operationRecordList {
        .operationListItem:first-child {
          color: #333;

          .timePoint {
            border-color: #36b374;
          }
        }

        .operationListItem:last-child {
          border-left: none;
        }

        .operationListItem {
          padding: 0 15px 30px 18px;
          color: #999;
          border-left: 1px solid #eaeaea;
          position: relative;

          .operationTitle {
            margin-bottom: 12px;
            font-size: 14px;
            font-weight: bold;
          }

          .operationTime {
            margin-bottom: 8px;
            font-size: 12px;
          }

          .operaterBox {
            margin-bottom: 6px;
            font-size: 12px;
          }

          .operationDetail {
            font-size: 12px;
            line-height: 16px;
          }

          .timePoint {
            width: 13px;
            height: 13px;
            background-color: #fff;
            border: 1px solid #eaeaea;
            border-radius: 50%;
            position: absolute;
            top: 0;
            left: -8px;
          }
        }
      }
    }

    .examinePicker {
      padding: 12px;

      .examinePickerTitle {
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: bold;
        line-height: 32x;
      }

      .examineBtns::after {
        content: "";
        display: block;
        clear: both;
      }

      .examineBtns {
        margin-bottom: 22px;

        > div {
          width: 64px;
          height: 28px;
          font-size: 12px;
          text-align: center;
          line-height: 28px;
          color: #36b374;
          border: 1px solid #36b374;
          border-radius: 2px;
          float: left;
        }

        > div.active {
          color: #fff;
          background-color: #36b374;
        }

        .throughExamine {
          margin-right: 12px;
        }
      }

      .examineMiddleBox {
        min-height: 75px;

        .examineOpinionBox {
          margin-bottom: 16px;
          font-size: 14px;
          color: #666;
        }

        .notThroughExamineTitile {
          font-size: 16px;
          font-weight: bold;
          line-height: 20px;
          color: #333;

          > span {
            margin-left: 4px;
            font-size: 12px;
            font-weight: normal;
            color: #999;
          }
        }

        .throughExamineTextBox {
          margin-bottom: 24px;
          // height: 120px;

          .throughExamineText {
            height: 120px;
            padding: 16px;
            font-size: 14px;
            background-color: #f5f5f5;
            border-radius: 4px;
          }
        }
      }

      .submitBtn {
        width: 100%;
        height: 50px;
        text-align: center;
        line-height: 50px;
        color: #fff;
        background-color: #9bd9ba;
        border-radius: 3px;
      }

      .submitBtn.active {
        background-color: #36b374;
      }
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }
    .fade-enter,
    .fade-leave-active {
      opacity: 0;
    }

    .examineDetailTipsBox {
      width: 120px;
      height: 124px;
      padding: 24px 0 0 0;
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.7);
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      > img {
        width: 50px;
        height: 50px;
        margin: 0 auto 12px;
        display: block;
      }

      > p {
        text-align: center;
        color: #fff;
      }
    }

    // .industryPop{
    //     padding: 10px 18px 0;

    //     .industryPopTop::after{
    //         content: '';
    //         display: block;
    //         clear: both;
    //     }

    //     .industryPopTop{
    //         margin-bottom: 25px;

    //         >div{
    //             font-size: 16px;
    //             font-weight: 400;
    //             line-height: 36px;
    //         }

    //         .cancelIndustryPop{
    //             float: left;
    //             color: #999;
    //         }

    //         .sureIndustry{
    //             float: right;
    //             color: #36B374;
    //         }
    //     }
    // }

    // .content {
    //     width: 100%;
    //     padding: 16px;
    //     box-sizing: border-box;
    //     .industryChoice {
    //         width: 100%;
    //         display: flex;
    //         justify-content: space-between;
    //         height: 38px;
    //         margin-top: 10px;
    //         .choice {
    //             height: 38px;
    //             line-height: 38px;
    //             font-size: 14px;
    //             color: #4A4A4A;
    //             font-weight: Medium;
    //         }
    //         .workOderNum {
    //             height: 38px;
    //             line-height: 38px;
    //             font-size: 12px;
    //             color: #999;
    //         }
    //     }
    //     .list {
    //         width: 100%;
    //         ul {
    //             li {
    //                 display: flex;
    //                 justify-content: space-between;
    //                 margin-bottom: 26px;
    //                 .left {
    //                     .workOrderID {
    //                         height: 12px;
    //                         line-height: 12px;
    //                         font-size: 12px;
    //                         color: #999;
    //                     }
    //                     .associationName {
    //                         height: 30px;
    //                         line-height: 30px;
    //                         font-size: 14px;
    //                         color: #333;
    //                         font-weight: Regular;
    //                     }
    //                     .sign {
    //                         display: flex;
    //                         height: 16px;
    //                         font-size: 12px;
    //                         .adress {
    //                             padding: 0 4px;
    //                             background-color: #36B374;
    //                             color: #fff;
    //                             font-size: 10px;
    //                             height: 16px;
    //                             line-height: 16px;
    //                         }
    //                         .classification {
    //                             padding: 0 4px;
    //                             color: #36B374;
    //                             background-color: #fff;
    //                             border: 0.5px solid #36B374;
    //                             font-size: 10px;
    //                             height: 16px;
    //                             line-height: 16px;
    //                             margin-left: 8px;
    //                         }
    //                     }
    //                 }
    //                 .right {
    //                     font-size: 14px;
    //                     color: #999;
    //                     line-height: 55px;
    //                 }
    //             }
    //         }
    //     }
    //     .createMessage,.commissionedParty,.involvedIndustries,.missionDetails {
    //         display: flex;
    //         .left {
    //             float: left;
    //             width: 30%;
    //             height: 30px;
    //             line-height: 30px;
    //             font-size: 14px;
    //             color: #999;
    //         }
    //         .right {
    //             float: left;
    //             width: 65%;
    //             margin-left: 12px;
    //             height: 30px;
    //             line-height: 30px;
    //             font-size: 14px;
    //             color: #333;
    //         }
    //     }
    //     .missionDetails {
    //         .right {
    //             height: auto;
    //         }
    //     }
    // }
  }
}
</style>
